import type { CheckoutPage, CheckoutTargetPage } from '@packages/gql/generated/shopping/graphql';
import type { OrderConfig } from '@packages/config/src/default/order/order.types';
import type { LocalizedPath } from '@packages/config/src/default';
import config from '@packages/config';

export const getTargetPageForPath = (
  pathname: string,
  paths: OrderConfig['paths'],
): CheckoutTargetPage => {
  type CheckoutEntry = { page: CheckoutTargetPage } & Record<string, string>;

  const checkoutEntries = (Object.values(paths) as Array<Record<string, string>>)
    .filter((path): path is CheckoutEntry => 'page' in path)
    .sort((a, b) => b.default.length - a.default.length);

  for (const { page, ...urlPaths } of checkoutEntries) {
    if (Object.values(urlPaths).some((p) => pathname.includes(p))) {
      return page;
    }
  }

  return 'CHECK_AND_ORDER';
};

export const getPathForTargetPage = (
  targetPage: CheckoutTargetPage,
  paths: OrderConfig['paths'],
): LocalizedPath | undefined => {
  type CheckoutEntry = { page: CheckoutTargetPage } & LocalizedPath;
  return (Object.values(paths) as Array<Record<string, unknown>>)
    .filter((path): path is CheckoutEntry => 'page' in path)
    .find(({ page }) => page === targetPage);
};

const stepByTargetPage: Partial<Record<CheckoutTargetPage, number>> = {
  BASKET: 1,
  LOGIN_PAGE: 2,
  DELIVERY_PAGE: 3,
  CHANGE_DELIVERY_PAGE: 3,
  PAYMENT_PAGE: 4,
  CHANGE_PAYMENT_PAGE: 4,
  CREDIT_PAYMENT_AD: 4,
  DELAYED_PAYMENT_AD: 4,
  INSURANCE_AD: 4,
  UPGRADE_INSURANCE_AD: 4,
  PREMIUM_AD: 4,
};

// Target pages without an own progress step (order confirmation, no-order hint)
// fall back to the last step.
export const getStepForTargetPage = (targetPage: CheckoutTargetPage): number =>
  stepByTargetPage[targetPage] ?? 5;

// This is to still support the old and deprecated types from the basket query
export type CheckoutPages = Record<CheckoutPage, LocalizedPath>;
export const checkoutPathByPage: CheckoutPages = {
  LoginPage: config.order.paths.login,
  CheckAndOrder: config.order.paths.checkandorder,
};
